











// // import React from "react";
// // import "@fortawesome/fontawesome-free/css/all.min.css";

// // export default function Booking({
// //  cards = [
// //   {
// //     title: "Hyundai Aura",
// //     company: "Urbania on Rent in Pune",
// //     seater: "4+1",
// //     priceLabel: "On Call",
// //     desc: "Hyundai Aura is a compact sedan offering comfortable seating, fuel efficiency, and smooth city rides—ideal for airport transfers, city tours, and small family trips.",
// //     image: "/images/gallery/aura.jpg",
// //   },
// //   {
// //     title: "Maruti Swift Dzire",
// //     company: "Urbania on Rent in Pune",
// //     seater: "4+1",
// //     priceLabel: "On Call",
// //     desc: "Swift Dzire is a popular sedan with spacious interiors, efficient performance, and smooth handling—perfect for city travel, airport drop-offs, and short trips.",
// //     image: "/images/gallery/swift-dzire.jpg",
// //   },
// //   {
// //     title: "Toyota Innova",
// //     company: "Urbania on Rent in Pune",
// //     seater: "7+1",
// //     priceLabel: "On Call",
// //     desc: "Toyota Innova is a reliable MPV offering premium comfort, ample luggage space, and AC cooling—ideal for family tours, corporate trips, and airport transfers.",
// //     image: "/images/gallery/innova.jpg",
// //   },
// //   {
// //     title: "Toyota Innova Crysta",
// //     company: "Urbania on Rent in Pune",
// //     seater: "7+1",
// //     priceLabel: "On Call",
// //     desc: "Innova Crysta combines luxury, space, and performance, making it perfect for group travel, long-distance trips, and corporate outings with premium seating and AC comfort.",
// //     image: "/images/gallery/innova-crysta.jpg",
// //   },
// // ],
// // }) {
// //   const handleWhatsAppBooking = (title) => {
// //     const phone = "919892544084";
// //     const message = `Hello Urbania on Rent in Pune, I want to book ${title}. Please share details.`;
// //     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
// //     window.open(url, "_blank");
// //   };

// //   return (
// //     <>

// //  <div className="breadcrumb-bar">
// //       <div className="container">
// //         <div className="row align-items-center text-center">
// //           <div className="col-md-12 col-12">
// //             <h2 className="breadcrumb-title">Booking</h2>
// //           </div>
// //         </div>
// //       </div>
// //     </div>

  

// //       {/* Cards */}
// //       <section
// //         className="taxi-rates-page section-space"
// //         style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
// //       >
// //         <div className="container">
// //           <div className="row g-4 justify-content-center">
// //             {cards.map((c, idx) => (
// //               <div className="col-xl-4 col-md-6 d-flex" key={idx}>
// //                 <div
// //                   className="taxi-card d-flex flex-column"
// //                   style={{
// //                     width: "100%",
// //                     backgroundColor: "#fff",
// //                     borderRadius: "12px",
// //                     overflow: "hidden",
// //                     boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
// //                     height: "100%",
// //                   }}
// //                 >
// //                   {/* Image */}
// //                   <div style={{ backgroundColor: "#00AFEB", padding: "20px" }}>
// //                     <img
// //                       src={c.image}
// //                       alt={c.title}
// //                       loading="lazy"
// //                       style={{
// //                         width: "100%",
// //                         maxHeight: "220px",
// //                         objectFit: "contain",
// //                       }}
// //                     />
// //                   </div>

// //                   {/* Content */}
// //                   <div
// //                     style={{
// //                       backgroundColor: "#606060",
// //                       color: "#fff",
// //                       padding: "25px 20px",
// //                       flex: "1",
// //                     }}
// //                     className="d-flex flex-column justify-content-between"
// //                   >
// //                     <div>
// //                       <h3 className="text-center mb-2">{c.title}</h3>
// //                       <p
// //                         className="text-center mb-3"
// //                         style={{ color: "#cfcfcf", fontSize: "0.9rem" }}
// //                       >
// //                         {c.company}
// //                       </p>

// //                       <p className="text-center mb-3">{c.desc}</p>

// //                       <p className="text-center fw-bold">
// //                         Seater: {c.seater}
// //                       </p>
// //                     </div>

// //                     <div className="text-center mt-3">
// //                       <button
// //                         onClick={() => handleWhatsAppBooking(c.title)}
// //                         className="btn d-inline-flex align-items-center justify-content-center"
// //                         style={{
// //                           backgroundColor: "#00AFEB",
// //                           color: "#fff",
// //                           padding: "10px 22px",
// //                           borderRadius: "6px",
// //                           border: "none",
// //                           fontWeight: 600,
// //                           width: "65%",
// //                         }}
// //                       >
// //                         <i className="fab fa-whatsapp me-2" /> Book Now
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }


// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// export default function Booking({
//   cards = [
//     {
//       title: "Hyundai Aura",
//       company: "Omshree Cab",
//       seater: "4+1",
//       priceLabel: "On Call",
//       desc: "Hyundai Aura is a compact sedan offering comfortable seating, fuel efficiency, and smooth city rides—ideal for airport transfers, city tours, and small family trips.",
//       image: "/images/fleets/aura.jpg",
//     },
//     {
//       title: "Maruti Suzuki Dzire",
//       company: "Omshree Cab",
//       seater: "4+1",
//       priceLabel: "On Call",
//       desc: "Maruti Suzuki Dzire is a popular sedan with spacious interiors, efficient performance, and smooth handling—perfect for city travel, airport drop-offs, and short trips.",
//       image: "/images/fleets/dsire.jpg",
//     },
//     {
//       title: "Toyota Innova",
//       company: "Omshree Cab",
//       seater: "7+1",
//       priceLabel: "On Call",
//       desc: "Toyota Innova is a reliable MPV offering premium comfort, ample luggage space, and AC cooling—ideal for family tours, corporate trips, and airport transfers.",
//       image: "/images/fleets/innova.jpg",
//     },
//     {
//       title: "Toyota Innova Crysta",
//       company: "Omshree Cab",
//       seater: "7+1",
//       priceLabel: "On Call",
//       desc: "Innova Crysta combines luxury, space, and performance, making it perfect for group travel, long-distance trips, and corporate outings with premium seating and AC comfort.",
//       image: "/images/fleets/innova-crysta.jpg",
//     },
//     {
//       title: "Maruti Suzuki Ertiga",
//       company: "Omshree Cab",
//       seater: "6+1",
//       priceLabel: "On Call",
//       desc: "Maruti Suzuki Ertiga is a spacious MPV offering comfort, flexibility, and efficiency—great for family outings and group travel.",
//       image: "/images/fleets/ertiga.jpg",
//     },
//     {
//       title: "Toyota Etios",
//       company: "Omshree Cab",
//       seater: "4+1",
//       priceLabel: "On Call",
//       desc: "Toyota Etios provides a comfortable and economical ride with sufficient space, perfect for city travel and airport transfers.",
//       image: "/images/fleets/etios.jpg",
//     },
//     {
//       title: "Kia Carens",
//       company: "Omshree Cab",
//       seater: "6+1",
//       priceLabel: "On Call",
//       desc: "Kia Carens offers modern design, spacious interiors, and smooth driving experience for family and group travel.",
//       image: "/images/fleets/kia.jpg",
//     },
//     {
//       title: "Tempo Traveller",
//       company: "Omshree Cab",
//       seater: "12-17",
//       priceLabel: "On Call",
//       desc: "Tempo Traveller is ideal for group travel, offering ample space, comfort, and reliability for long journeys.",
//       image: "/images/fleets/tempo-trevellar.jpg",
//     },
//     {
//       title: "Mini Bus",
//       company: "Omshree Cab",
//       seater: "20-25",
//       priceLabel: "On Call",
//       desc: "Mini Bus provides group transport with comfort and safety, perfect for tours, corporate events, and large groups.",
//       image: "/images/fleets/mini-bus.jpg",
//     },
//     {
//       title: "Luxury Bus",
//       company: "Omshree Cab",
//       seater: "40-50",
//       priceLabel: "On Call",
//       desc: "Luxury Bus offers premium seating and amenities for large groups, ideal for long-distance travel and special occasions.",
//       image: "/images/fleets/bus.jpg",
//     },
//     {
//       title: "Audi Luxury Car",
//       company: "Omshree Cab",
//       seater: "4+1",
//       priceLabel: "On Call",
//       desc: "Audi Luxury Car delivers high-end comfort, style, and performance for executive travel and special rides.",
//       image: "/images/fleets/audi.jpg",
//     },
//   ],
// }) {
//   const handleWhatsAppBooking = (title) => {
//     const phone = "919892544084";
//     const message = `Hello Omshree Cab, I want to book ${title}. Please share details.`;
//     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <>
//       <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title">Booking</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       <section
//         className="taxi-rates-page section-space"
//         style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
//       >
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {cards.map((c, idx) => (
//               <div className="col-xl-4 col-md-6 d-flex" key={idx}>
//                 <div
//                   className="taxi-card d-flex flex-column"
//                   style={{
//                     width: "100%",
//                     backgroundColor: "#fff",
//                     borderRadius: "12px",
//                     overflow: "hidden",
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//                     height: "100%",
//                   }}
//                 >
//                   {/* Image */}
//                   <div style={{ backgroundColor: "#00AFEB", padding: "20px" }}>
//                     <img
//                       src={c.image}
//                       alt={c.title}
//                       loading="lazy"
//                       style={{
//                         width: "100%",
//                         maxHeight: "220px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       backgroundColor: "#606060",
//                       color: "#fff",
//                       padding: "25px 20px",
//                       flex: "1",
//                     }}
//                     className="d-flex flex-column justify-content-between"
//                   >
//                     <div>
//                       <h3 className="text-center mb-2">{c.title}</h3>
//                       <p
//                         className="text-center mb-3"
//                         style={{ color: "#cfcfcf", fontSize: "0.9rem" }}
//                       >
//                         {c.company}
//                       </p>

//                       <p className="text-center mb-3">{c.desc}</p>

//                       <p className="text-center fw-bold">Seater: {c.seater}</p>
//                     </div>

//                     <div className="text-center mt-3">
//                       <button
//                         onClick={() => handleWhatsAppBooking(c.title)}
//                         className="btn d-inline-flex align-items-center justify-content-center"
//                         style={{
//                           backgroundColor: "#00AFEB",
//                           color: "#fff",
//                           padding: "10px 22px",
//                           borderRadius: "6px",
//                           border: "none",
//                           fontWeight: 600,
//                           width: "65%",
//                         }}
//                       >
//                         <i className="fab fa-whatsapp me-2" /> Book Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }


import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Booking({
  cards = [
    {
      title: "Hyundai Aura",
      company: "Omshree Cab",
      seater: "4+1",
      priceLabel: "On Call",
      desc: "Hyundai Aura is a compact sedan offering comfortable seating, fuel efficiency, and smooth city rides—ideal for airport transfers, city tours, and small family trips.",
      specs: {
        fuel: "Petrol/CNG",
        ac: "Yes",
        luggage: "2 Bags",
        transmission: "Manual",
      },
      image: "/images/fleets/aura.jpg",
    },
    {
      title: "Maruti Suzuki Dzire",
      company: "Omshree Cab",
      seater: "4+1",
      priceLabel: "On Call",
      desc: "Maruti Suzuki Dzire is a popular sedan with spacious interiors, efficient performance, and smooth handling—perfect for city travel, airport drop-offs, and short trips.",
      specs: {
        fuel: "Petrol/CNG",
        ac: "Yes",
        luggage: "2 Bags",
        transmission: "Manual",
      },
      image: "/images/fleets/dsire.jpg",
    },
    {
      title: "Toyota Innova",
      company: "Omshree Cab",
      seater: "7+1",
      priceLabel: "On Call",
      desc: "Toyota Innova is a reliable MPV offering premium comfort, ample luggage space, and AC cooling—ideal for family tours, corporate trips, and airport transfers.",
      specs: {
        fuel: "Diesel",
        ac: "Yes",
        luggage: "4–5 Bags",
        transmission: "Manual",
      },
      image: "/images/fleets/innova.jpg",
    },
    {
      title: "Toyota Innova Crysta",
      company: "Omshree Cab",
      seater: "7+1",
      priceLabel: "On Call",
      desc: "Innova Crysta combines luxury, space, and performance, making it perfect for group travel, long-distance trips, and corporate outings with premium seating and AC comfort.",
      specs: {
        fuel: "Diesel",
        ac: "Yes",
        luggage: "4–5 Bags",
        transmission: "Manual/Auto",
      },
      image: "/images/fleets/innova-crysta.jpg",
    },
    {
      title: "Maruti Suzuki Ertiga",
      company: "Omshree Cab",
      seater: "6+1",
      priceLabel: "On Call",
      desc: "Maruti Suzuki Ertiga is a spacious MPV offering comfort, flexibility, and efficiency—great for family outings and group travel.",
      specs: {
        fuel: "Petrol/CNG",
        ac: "Yes",
        luggage: "3–4 Bags",
        transmission: "Manual",
      },
      image: "/images/fleets/ertiga.jpg",
    },
    {
      title: "Toyota Etios",
      company: "Omshree Cab",
      seater: "4+1",
      priceLabel: "On Call",
      desc: "Toyota Etios provides a comfortable and economical ride with sufficient space, perfect for city travel and airport transfers.",
      specs: {
        fuel: "Diesel/Petrol",
        ac: "Yes",
        luggage: "2 Bags",
        transmission: "Manual",
      },
      image: "/images/fleets/etios.jpg",
    },
    {
      title: "Kia Carens",
      company: "Omshree Cab",
      seater: "6+1",
      priceLabel: "On Call",
      desc: "Kia Carens offers modern design, spacious interiors, and smooth driving experience for family and group travel.",
      specs: {
        fuel: "Petrol/Diesel",
        ac: "Yes",
        luggage: "3–4 Bags",
        transmission: "Manual/Auto",
      },
      image: "/images/fleets/kia.jpg",
    },
    {
      title: "Tempo Traveller",
      company: "Omshree Cab",
      seater: "12-17",
      priceLabel: "On Call",
      desc: "Tempo Traveller is ideal for group travel, offering ample space, comfort, and reliability for long journeys.",
      specs: {
        fuel: "Diesel",
        ac: "Yes",
        luggage: "Large Capacity",
        transmission: "Manual",
      },
      image: "/images/fleets/tempo-trevellar.jpg",
    },
    {
      title: "Mini Bus",
      company: "Omshree Cab",
      seater: "20-25",
      priceLabel: "On Call",
      desc: "Mini Bus provides group transport with comfort and safety, perfect for tours, corporate events, and large groups.",
      specs: {
        fuel: "Diesel",
        ac: "Yes",
        luggage: "High Capacity",
        transmission: "Manual",
      },
      image: "/images/fleets/mini-bus.jpg",
    },
    {
      title: "Luxury Bus",
      company: "Omshree Cab",
      seater: "40-50",
      priceLabel: "On Call",
      desc: "Luxury Bus offers premium seating and amenities for large groups, ideal for long-distance travel and special occasions.",
      specs: {
        fuel: "Diesel",
        ac: "Yes",
        luggage: "Very High Capacity",
        transmission: "Manual",
      },
      image: "/images/fleets/bus.jpg",
    },
    {
      title: "Audi Luxury Car",
      company: "Omshree Cab",
      seater: "4+1",
      priceLabel: "On Call",
      desc: "Audi Luxury Car delivers high-end comfort, style, and performance for executive travel and special rides.",
      specs: {
        fuel: "Petrol",
        ac: "Yes",
        luggage: "2 Bags",
        transmission: "Automatic",
      },
      image: "/images/fleets/audi.jpg",
    },
  ],
}) {
  const handleWhatsAppBooking = (title) => {
    const phone = "919892544084";
    const message = `Hello Omshree Cab, I want to book ${title}. Please share details.`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Booking</h2>
            </div>
          </div>
        </div>
      </div>

      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => (
              <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                <div
                  className="taxi-card d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  {/* Image */}
                  <div style={{ backgroundColor: "#00AFEB", padding: "20px" }}>
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      backgroundColor: "#606060",
                      color: "#fff",
                      padding: "25px 20px",
                      flex: "1",
                    }}
                    className="d-flex flex-column justify-content-between"
                  >
                    <div>
                      <h3 className="text-center mb-2">{c.title}</h3>

                      <p
                        className="text-center mb-3"
                        style={{ color: "#cfcfcf", fontSize: "0.9rem" }}
                      >
                        {c.company}
                      </p>

                      {/* Split Layout */}
                      <div className="row">
                        {/* Description */}
                        <div className="col-12">
                          <p style={{ fontSize: "0.85rem" }}>{c.desc}</p>
                        </div>

                        {/* Specs */}
                        {/* <div className="col-6">
                          <ul
                            style={{
                              listStyle: "none",
                              padding: 0,
                              fontSize: "0.85rem",
                            }}
                          >
                            <li><strong>Fuel:</strong> {c.specs?.fuel}</li>
                            <li><strong>AC:</strong> {c.specs?.ac}</li>
                            <li><strong>Luggage:</strong> {c.specs?.luggage}</li>
                            <li><strong>Gear:</strong> {c.specs?.transmission}</li>
                          </ul>
                        </div> */}
                      </div>

                      <p className="text-center fw-bold mt-3">
                        Seater: {c.seater}
                         <li><strong>Fuel:</strong> {c.specs?.fuel}</li>
                            <li><strong>AC:</strong> {c.specs?.ac}</li>
                            {/* <li><strong>Luggage:</strong> {c.specs?.luggage}</li> */}
                            {/* <li><strong>Gear:</strong> {c.specs?.transmission}</li> */}
                      </p>
                      
                    </div>

                    <div className="text-center mt-3">
                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#00AFEB",
                          color: "#fff",
                          padding: "10px 22px",
                          borderRadius: "6px",
                          border: "none",
                          fontWeight: 600,
                          width: "65%",
                        }}
                      >
                        <i className="fab fa-whatsapp me-2" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}